"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const TaskPage_1 = require("../../base/TaskPage");
const autosave_1 = require("../../../../hooks/autosave");
const viewstate_1 = require("../../../../entities/viewstate");
const constants_1 = require("../../../../entities/contracts/constants");
const IconTextSpan_1 = require("../../../components/icon-text-span/IconTextSpan");
const styled_1 = __importDefault(require("@emotion/styled"));
const theme_1 = __importDefault(require("../../../components/styles/theme"));
const Checkbox_1 = require("../../../components/input/checkbox/Checkbox");
const helpers_1 = require("./helpers");
const IconListItem_1 = require("../../../components/icon-list-item/IconListItem");
const constants_2 = require("../../../../tasks/constants");
const ValidationContext_1 = require("../../../../context/ValidationContext");
const FormTextArea_1 = require("../../../components/input/text/FormTextArea");
const Spacer_1 = require("../../../components/spacer/Spacer");
const HorizontalRule_1 = require("../../../components/horizontal-rule/HorizontalRule");
const Heading_1 = require("../../../components/heading/Heading");
const MarginWrapper_1 = require("../../../components/margin/MarginWrapper");
const TermsAgreementCheckboxWrapper = styled_1.default.div `
	display: flex;
	align-items: center;
	margin: ${theme_1.default.layout.spacing.smaller} auto;
	background-color: ${props => props.alreadyAgreed ? theme_1.default.palette.green.tint : theme_1.default.palette.red.tint};
	padding: ${theme_1.default.layout.spacing.small};
	${theme_1.default.typography.b1};
	> span {
		margin-left: ${theme_1.default.layout.spacing.smaller}
	}
`;
const FullTermsWrapper = styled_1.default.div `
	margin-top: ${theme_1.default.layout.spacing.standard};
	& > textarea {
		${theme_1.default.typography.b1};
		width:100%;
		max-width: 50ch;
		height: 400px;
		resize: none;
	}
`;
const TypographyStyleWrapper = styled_1.default.div `
	${theme_1.default.typography.b1};
`;
exports.default = (props) => {
    const { property, viewState: propertyViewState } = (0, autosave_1.useAutoSaveProperty)(props.propertyId);
    const { termsContracts, viewState: termsViewState, update, lastSaved, updaterError, getterError } = (0, autosave_1.useAutoSaveTermsContracts)(props.customerId);
    const tsAndCsTerms = termsContracts === null || termsContracts === void 0 ? void 0 : termsContracts.find((c) => c.terms_id === constants_1.SignupTermsConditions[0].termsId);
    const alreadyAgreed = tsAndCsTerms ? tsAndCsTerms.agreed : false;
    const contextualMessage = alreadyAgreed ? undefined : 'You must accept the terms and conditions below.';
    const { dispatch: validationDispatch } = React.useContext(ValidationContext_1.ValidationContext);
    React.useEffect(() => {
        if (alreadyAgreed) {
            validationDispatch(ValidationContext_1.validationActions.updateTerms(true));
        }
    }, [alreadyAgreed]);
    return (React.createElement(TaskPage_1.TaskPage, { task: constants_2.Tasks.TERMS_CONDITIONS, property: property, viewState: (0, viewstate_1.combineViewStates)(propertyViewState, termsViewState), lastSaved: lastSaved, getterError: getterError, updaterError: updaterError, contextualMessage: contextualMessage },
        React.createElement(TaskPage_1.TaskLayout, { width: 50 },
            React.createElement(HorizontalRule_1.HorizontalRule, null),
            React.createElement(Spacer_1.Spacer, { spacing: "large" }),
            React.createElement(TaskPage_1.TaskColumn, null,
                React.createElement(MarginWrapper_1.MarginWrapper, null,
                    React.createElement(Heading_1.HeadingSmall, null, "Key points"),
                    React.createElement(Spacer_1.Spacer, { spacing: "small" }),
                    React.createElement(IconListItem_1.IconListItem, { icon: 'star', display: 'primary' },
                        React.createElement("p", null, "We accept bookings from channels on your behalf. This means you are bound by the terms and conditions of the channels you choose to list on.")),
                    React.createElement(Spacer_1.Spacer, { spacing: "small" }),
                    React.createElement(IconListItem_1.IconListItem, { icon: 'star', display: 'primary' },
                        React.createElement("p", null, "We use Instant Book to confirm all bookings which are automatically updated in your Travelnest calendar."),
                        React.createElement("p", null, "It is essential that you block out any unavailable dates to prevent double bookings.")),
                    React.createElement(Spacer_1.Spacer, { spacing: "small" }),
                    React.createElement(IconListItem_1.IconListItem, { icon: 'star', display: 'primary' },
                        React.createElement("p", null,
                            "If you request us to cancel a booking after we have confirmed the booking with the guest, we reserve the right to charge you any costs ",
                            React.createElement("strong", null, "charged by the channel"),
                            " such as relocation or cancellation fees if they deem the reason not to be an extenuating circumstance."),
                        React.createElement(Spacer_1.Spacer, { spacing: "small" }),
                        React.createElement("p", null, "We also reserve the right to charge an administration fee of \u00A350+VAT (where applicable).")),
                    React.createElement(Spacer_1.Spacer, { spacing: "small" }),
                    React.createElement(IconListItem_1.IconListItem, { icon: 'star', display: 'primary' },
                        React.createElement("p", null, "To close your account, please contact owners@travelnest.com."),
                        React.createElement("p", null, "Listings can take up to 7 days to be removed from channels, and you are still responsible for any bookings received until your listings are removed.")),
                    React.createElement(Spacer_1.Spacer, null),
                    React.createElement(TypographyStyleWrapper, null,
                        React.createElement(FullTermsWrapper, null,
                            React.createElement(FormTextArea_1.FormTextArea, { id: "terms-and-conditions-textarea", label: "Full terms and conditions", value: constants_1.SignupTermsConditions[0].fullTerms, onChange: () => ({}), valid: true, disabled: true }))),
                    alreadyAgreed && React.createElement(React.Fragment, null,
                        React.createElement(Spacer_1.Spacer, null),
                        React.createElement(IconTextSpan_1.IconTextSpan, { icon: 'check', display: 'success', iconSize: 'large', text: `You agreed to these terms and conditions on ${(0, helpers_1.formatSignedDate)(tsAndCsTerms.signed)}` }),
                        React.createElement(Spacer_1.Spacer, null)),
                    React.createElement(TermsAgreementCheckboxWrapper, { alreadyAgreed: alreadyAgreed },
                        React.createElement(Checkbox_1.Checkbox, { onChange: (_, checked) => {
                                const otherTerms = (termsContracts || []).filter((t) => t.terms_id !== constants_1.SignupTermsConditions[0].termsId);
                                update([
                                    ...otherTerms,
                                    { terms_id: constants_1.SignupTermsConditions[0].termsId, agreed: checked, customer: props.customerId, signed: new Date().toISOString() }
                                ]);
                            }, name: `terms-and-conditions`, checked: alreadyAgreed, disabled: alreadyAgreed }),
                        React.createElement("span", null, "I have read and accepted the Travelnest terms and conditions.")))))));
};
//# sourceMappingURL=TermsAndConditions.js.map